<template>
  <div class="comp-login">
    <div class="content">
      <div class="row-item title">用户登录</div>
      <a-input
        v-model="account"
        class="row-item"
        placeholder="账号"></a-input>
      <a-input
        v-model="password"
        class="row-item"
        type="password"
        placeholder="密码"></a-input>
      <a-button
        class="row-item btn"
        type="primary"
        block
        @click="handleLogin()">
        登录
      </a-button>
      <div style="position: absolute;bottom: 2px;left: 40%;font-size: 10px">
        <span><img style="width: 14px;height: 14px;margin-right: 3px" src="@/assets/favicon_zjuidg.svg"/></span>
        <span style="color: #000">Powered by ZJUIDG</span>
        <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="beian"
             style="object-fit: contain; width: 10px;margin-right: 3px;margin-left: 3px"/>
        <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002017572" target="_blank"
           style="color: #000">浙公网安备33011002017572号</a>
        <span>&nbsp;</span>
        <a href="https://beian.miit.gov.cn/" target="_blank"
           style="color: #000">&nbsp;浙ICP备2023048561号-1</a>
      </div>
    </div>

  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { userLogin } from '../api/index'

export default {
  name: 'Login',
  components: {
  },
  data(){
    return {
      account: '',
      password: '',
    }
  },
  mounted() {
    const userInfo = this.$store.state.userInfo
    if(userInfo) {
      this.$router.push('/list')
    }
  },
  methods: {
    async handleLogin() {
      if(!this.account){
        message.error('账号不能为空')
        return
      }
      if(!this.password){
        message.error('密码不能为空')
        return
      }
      const passData = {
        username: this.account,
        password: this.password,
      }

      const response = await userLogin({ data: passData })
      if(response.status === 200) {
        if(response.data.success) {
          this.$store.commit('setUserInfo', {name:this.account})
          this.$store.commit('setToken', response.data.token)
          this.$router.push('/list')
        }
      }

    }
  }

}
</script>
<style lang="less">

.comp-login {
  height: calc(100vh - 66px);
  width: 100vw;
  position: relative;
  background-image: url('~@/assets/background.png');
  background-repeat: repeat;
  background-size: 600px 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  .content{
    width: 494px;
    height: 400px;
    .title {
      font-family: 'Microsoft YaHei UI';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 36px;
      /* identical to box height, or 180% */

      text-align: center;
      letter-spacing: -0.015em;
    }
    .row-item {
      margin-bottom: 40px;
      height:60px;
    }

    .btn {
      background: #0072BE;
      font-family: 'Microsoft YaHei UI';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 25px;
      text-align: center;
      letter-spacing: -0.015em;
    }
  }
}
</style>
